import { createContext, useCallback, useContext, useEffect, useMemo, useReducer } from 'react';
import { CommentsPropsContext } from '../../contexts/comments/PropsContext';
import { loggingMiddleware } from '../../utils/store';
import { appActions } from '../app/context';
import { createNewComment, deleteExistingComment, fetchOwners, getComments, updateExistingComment } from './functions';
import { CREATE_COMMENT, DELETE_COMMENT, GET_COMMENTS, initialState, reducer, SET_SNIPPETS_LOADING, UPDATE_COMMENT } from './reducer';
import { jsx as _jsx } from "react/jsx-runtime";
export const CommentsContext = /*#__PURE__*/createContext(initialState);
export const CommentsContextProvider = ({
  children
}) => {
  const [comments, dispatchCTX] = useReducer(loggingMiddleware('comments')(reducer), initialState);
  const {
    apiWrapper
  } = useContext(CommentsPropsContext);
  const asyncFuncArg = useMemo(() => ({
    dispatch: dispatchCTX,
    postponeWithAppLoader: appActions.postponeWithAppLoader,
    apiWrapper
  }), [apiWrapper]);
  const dispatch = useCallback(action => {
    switch (action.type) {
      case GET_COMMENTS:
        {
          getComments(asyncFuncArg, action.payload);
          return;
        }
      case CREATE_COMMENT:
        {
          createNewComment(asyncFuncArg, action.payload);
          return;
        }
      case DELETE_COMMENT:
        {
          deleteExistingComment(asyncFuncArg, action.payload);
          return;
        }
      case UPDATE_COMMENT:
        {
          updateExistingComment(asyncFuncArg, action.payload);
          return;
        }
      default:
        {
          dispatchCTX(action);
        }
    }
  }, [asyncFuncArg]);
  const actions = useMemo(() => ({
    getComments: data => {
      return dispatch({
        type: GET_COMMENTS,
        payload: data
      });
    },
    createComment: data => dispatch({
      type: CREATE_COMMENT,
      payload: data
    }),
    deleteComment: commentId => dispatch({
      type: DELETE_COMMENT,
      payload: commentId
    }),
    updateComment: data => dispatch({
      type: UPDATE_COMMENT,
      payload: data
    }),
    setSnippetLoading: value => dispatch({
      type: SET_SNIPPETS_LOADING,
      payload: value
    })
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const state = useMemo(() => Object.assign({}, comments, {
    dispatch,
    commentsActions: actions
  }), [comments, dispatch, actions]);

  // fetch owners need to be done only once
  useEffect(() => {
    fetchOwners(asyncFuncArg);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsx(CommentsContext.Provider, {
    value: state,
    children: children
  });
};